import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITheme } from "./Theme.types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { PersistConfig, persistReducer } from "redux-persist";

export interface ThemeState {
  active: string | null; // key of the active theme
  themes: ITheme[];
}

const initialState: ThemeState = {
  active: null,
  themes: [],
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setActiveTheme: (state: ThemeState, action: PayloadAction<string>) => {
      state.active = action.payload;
    },
    setThemes: (state: ThemeState, action: PayloadAction<ITheme[]>) => {
      state.themes = action.payload;
    },
  },
});

const persistConfig: PersistConfig<ThemeState> = {
  key: "theme",
  storage: AsyncStorage,
  whitelist: ["active"],
};

export const themeActions = themeSlice.actions;

export default persistReducer(persistConfig, themeSlice.reducer);
